// extracted by mini-css-extract-plugin
export default {"errorBoundary__container":"ErrorBoundary_errorBoundary__container__eE9KZ","errorBoundary__message":"ErrorBoundary_errorBoundary__message__JV3Ky"};